export const  truncateText = (inputText) => {
    if (inputText && inputText.length > 20) {
      return inputText.substring(0, 20) + "...";
    }
    return inputText;
  }